import { motion } from 'framer-motion'
import { UserGroupIcon, HomeIcon } from '@heroicons/react/24/outline'

export default function ProblemSection({ t }) {
  return (
    <section className="section-padding bg-warm-sand">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-5xl font-display font-bold text-neutral-900 mb-6">
            {t.problem.title}
          </h2>
        </motion.div>

        {/* Stats Cards */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="card flex items-start gap-4"
          >
            <div className="bg-primary-100 rounded-2xl p-4">
              <HomeIcon className="h-8 w-8 text-primary-600" />
            </div>
            <div>
              <p className="text-3xl font-bold text-neutral-900 mb-2">~40%</p>
              <p className="text-neutral-600">{t.problem.stat1}</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="card flex items-start gap-4"
          >
            <div className="bg-primary-100 rounded-2xl p-4">
              <UserGroupIcon className="h-8 w-8 text-primary-600" />
            </div>
            <div>
              <p className="text-3xl font-bold text-neutral-900 mb-2">4,000+</p>
              <p className="text-neutral-600">{t.problem.stat2}</p>
            </div>
          </motion.div>
        </div>

        {/* Core Message */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-center max-w-3xl mx-auto"
        >
          <p className="text-2xl md:text-3xl font-medium text-neutral-800 mb-6 leading-relaxed">
            {t.problem.description}
          </p>
          <p className="text-xl text-primary-600 font-medium">
            {t.problem.notSurveillance}
          </p>
        </motion.div>
      </div>
    </section>
  )
}
